export const formatMoneyAmount = (number) => {
  const config = {
    style: 'currency',
    currency: 'USD',
  };
  if (number === undefined || isNaN(number))
    number = 0;
  if(typeof number === 'string')
    number = parseFloat(number)
  return number.toLocaleString('en-US', config);
};

export const formatMoneyAmountNoDecimal = (number) => {
  if (number === undefined || isNaN(number))
    number = 0;
  if(typeof number === 'string')
    number = parseInt(number)
  const config = {
    currency: 'USD',
  };
  return number.toLocaleString('en-US', config);
};
